import React, { useState, useEffect } from 'react';
import RestaurantMap from './ReataurantMap';
import locationsMetadata from './locationsData';
import {Link} from 'react-router-dom';

export default function LocationsView() {
    return(
        <div id="pick-locations" role="main" aria-labelledby="location-header">

       
          
<RestaurantMap />
  <div className="location-list">{locationsMetadata.map(({id, disabled, buttonLabel, openingDate, label, address, phone, hours, phoneLink, orderLink, className="", external}) => (
      <div key={id} className={"grid-item location " + className}>
        <div className="location-list-content">
          <h3 className="title">{label} Location</h3>


          


   
          
          {!disabled && <div className="loc-menu-link">
            <a href={orderLink} 
            aria-label={"Order Pickup or Delivery for " + label + " location"}
            className="menu-location-link">
            <span className="menu-button">Order Pickup / Delivery</span></a>

            <span className="separator">
                ·
            </span>
            <a 
            aria-label={"Menu for " + label + " location"}
            href={orderLink} className="menu-location-link"><span className="menu-button">{"Menu"}</span></a>
          </div>}

          {/* <p>{external ? 
          <a href={orderLink} className="menu-location-link">
          <span className="order-button">Order Pickup / Delivery</span></a> :
          <Link to={orderLink} 
            aria-label={"Order Pickup or Delivery for " + label + " location"}
            className="order-location-link">
            <span className="order-button">Order Pickup / Delivery</span></Link>
            }
          </p> */}
          <div className="address">
            {address[0]} <br/>
            {address[1]}
          </div>
          <div className="phone">
            <a
              className="phone-link"
              href={`tel:${phoneLink}`}>{phone}</a>
          </div>
          <ul className="hours-of-operation">
            {hours.map((hours) => {
              return (<li key={hours.day}>
                <span className="">{hours.day}: {hours.hours}</span>
                {/* <span className="hours">{hours.hours}</span> */}
              </li>)
            })}
          </ul>

          {(id === 'kluckinva') && <div className="hiring">
            <Link className="order-button hire" to="/jobs">We're Hiring →</Link>
          </div>}
        </div>
      </div>
    ))}
  </div>
  

</div>  

    )
}